<template>
  <div>
    <div class="tw-flex tw-gap-4 tw-mb-4">
      <div class="tw-flex-1">
        <label for="meeting-title" class="tw-block tw-mb-1 tw-font-medium">
          {{ copy.titleLabel }}
        </label>
        <SfInput
          v-model="title[meetingId]"
          component-type="input"
          name="meeting-title"
          class="sf-form-input"
          data-testid="meeting-title"
          :placeholder="copy.optionalPlaceholder"
          :focused="true"
        />
      </div>
      <div class="tw-flex-none tw-w-30">
        <label for="meeting-date" class="tw-block tw-mb-1 tw-font-medium">
          {{ copy.dateLabel }}
        </label>
        <div class="tw-flex tw-items-center">
          <DatePicker
            v-model="completedDate[meetingId]"
            name="meeting-date"
            :icon="true"
            class="!tw-leading-4"
            data-testid="meeting-date"
          />
        </div>
      </div>
    </div>
    <label
      class="tw-block tw-mb-2 tw-font-medium tw-text-sf-neutral-dark-2"
      for="meeting-summary-editor"
    >
      {{ copy.summaryLabel }}
    </label>
    <SfMarkdownEditor
      v-model="summary[meetingId]"
      :mention-usernames="[]"
      :mention-accounts="mentionAccounts"
      :mention-recon-templates="mentionReconTemplates"
      :is-loading-accounts="isLoadingAccounts"
      :is-loading-recon-templates="isLoadingReconTemplates"
      data-testid="meeting-summary-editor"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfInput } from '@app/shared/vue/components/sf-input'
import DatePicker from '@app/shared/vue/components/form/date-picker.vue'
import SfMarkdownEditor from '@app/shared/vue/components/sf-markdown-editor/sf-markdown-editor.vue'
import { useMentionablesStore } from '@app/application/communication/store/mentionables'
import { useMeetingDetailsStore } from '@app/application/client_meetings/screens/past/stores/meeting-details'

const I18n = useI18n()
const copy = {
  titleLabel: I18n.t('client_meetings.past.meeting_form.meeting_title'),
  optionalPlaceholder: I18n.t('common.optional'),
  dateLabel: I18n.t('client_meetings.past.meeting_form.date'),
  summaryLabel: I18n.t('client_meetings.past.meeting_form.meeting_summary'),
}

const mentionablesStore = useMentionablesStore()
const {
  mentionAccounts,
  mentionReconTemplates,
  isLoadingAccounts,
  isLoadingReconTemplates,
} = storeToRefs(mentionablesStore)

interface Props {
  meetingId: number
}

defineProps<Props>()

const meetingDetails = useMeetingDetailsStore()
const { summary, completedDate, title } = storeToRefs(meetingDetails)

mentionablesStore.initialize(
  window.Silverfin.currentCompanyId,
  window.Silverfin.currentLedgerId().toString()
)
</script>
